import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import ServicePage from "./pages/ServicePage";
import BlogPage from "./pages/BlogPage";
import EsopTool from "./pages/EsopTool";
import CashflowTool from "./pages/CashflowTool";
import HealthCheck from "./pages/HealthCheck";
import LandingPage from "./pages/LandingPage";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView({ behavior: "smooth" });
        }, 100);
        return;
      }
    }
    window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return null;
}

function MarketingLayout({ children }) {
  return (
    <>
      <Nav />
      {children}
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    document.title = "CFOSutra — Outsourced Finance Team for Founder-Run Businesses | Bengaluru";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Part-time CFO & accounting services in Bengaluru. Bookkeeping · Payroll · GST · Fractional CFO. Books closed by the 5th, every month.");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<MarketingLayout><Home /></MarketingLayout>} />
          <Route path="/pricing" element={<MarketingLayout><Pricing /></MarketingLayout>} />
          <Route path="/services/:slug" element={<MarketingLayout><ServicePage /></MarketingLayout>} />
          <Route path="/insights/:slug" element={<MarketingLayout><BlogPage /></MarketingLayout>} />
          <Route path="/resources/esop-toolkit" element={<MarketingLayout><EsopTool /></MarketingLayout>} />
          <Route path="/resources/cashflow-forecast" element={<MarketingLayout><CashflowTool /></MarketingLayout>} />
          <Route path="/resources/health-check" element={<MarketingLayout><HealthCheck /></MarketingLayout>} />
          <Route path="/lp/:variant" element={<MarketingLayout><LandingPage /></MarketingLayout>} />
        </Routes>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#0d2b1f", color: "#f7f6f2", border: "1px solid rgba(247,246,242,0.15)" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
